import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Document = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 3C4.67157 3 4 3.67157 4 4.5V19.5C4 20.3284 4.67157 21 5.5 21H18.5C19.3284 21 20 20.3284 20 19.5V4.5C20 3.67157 19.3284 3 18.5 3H5.5ZM5 4.5C5 4.22386 5.22386 4 5.5 4H18.5C18.7761 4 19 4.22386 19 4.5V19.5C19 19.7761 18.7761 20 18.5 20H5.5C5.22386 20 5 19.7761 5 19.5V4.5ZM8 7.5C7.72386 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.72386 8.5 8 8.5H16C16.2761 8.5 16.5 8.27614 16.5 8C16.5 7.72386 16.2761 7.5 16 7.5H8ZM8 11.5C7.72386 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5H16C16.2761 12.5 16.5 12.2761 16.5 12C16.5 11.7239 16.2761 11.5 16 11.5H8ZM7.5 16C7.5 15.7239 7.72386 15.5 8 15.5H13C13.2761 15.5 13.5 15.7239 13.5 16C13.5 16.2761 13.2761 16.5 13 16.5H8C7.72386 16.5 7.5 16.2761 7.5 16Z"
        fill={color}
      />
      <path
        d="M20 3.5H5V19.5C5 20.0523 5.44772 20.5 6 20.5L19 20.5C19.5523 20.5 20 20.0523 20 19.5V3.5Z"
        fill={color}
        fillOpacity="0.05"
      />
    </svg>
  )
})

export default Document
